// extracted by mini-css-extract-plugin
export default {"menuBlock":"zI-z","title":"AI-z","nav":"BI-z","flexCell":"CI-z","facetLink":"DI-z"};